import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
import {
  Button,
  Modal,
  Form,
  List,
  Heading,
  getClassNameFactory,
  Typography,
} from '@dcl/ui';
import { ButtonKind, ButtonColor } from '@dcl/ui/dist/elements/Button';
import { Animation } from '@dcl/ui/dist/modules/Modal/ModalConstants';
import { IMobileViewProps } from '../types';
import { unorderedStyles } from '@dcl/ui/dist/fragments/List/ListTypes';
import { types } from '@dcl/ui/dist/elements/Heading';
import { ProductSelection } from '../ProductSelection';
import { SEARCH_OR_SELECT } from '../helpers/constants';
import '../index.css';

const MobileView = ({
  mobileProductList,
  handleMobileInputChange,
  mobileInputValue,
  browseLabel,
  buttonLabel,
}: IMobileViewProps) => {
  const [modalState, setModalState] = useState(false);
  const handleModalToggle = () => {
    setModalState(!modalState);
  };
  const getClassName = getClassNameFactory(ProductSelection.displayName);
  return (
    <div className={getClassName({ descendantName: 'mobileContainer' })}>
      {modalState && (
        <Modal
          animation={Animation.SLIDELEFT}
          ariaLabel="Product selection modal"
          closeThisComponent={handleModalToggle}
          closeLabel="Close"
          className={getClassName({ descendantName: 'mobileModalContainer' })}
        >
          <div
            className={getClassName({
              descendantName: 'mobileFormContainer',
            })}
          >
            <div
              className={getClassName({
                descendantName: 'mobileTypographyContainer',
              })}
            >
              <Typography
                className={getClassName({
                  descendantName: 'mobileDropdownLabel',
                })}
              >
                {SEARCH_OR_SELECT}
              </Typography>
            </div>
            <div
              className={getClassName({
                descendantName: 'mobileTextContainer',
              })}
            >
              <Form.TextControl
                id="input1"
                name="input1"
                onChange={(e: any) => handleMobileInputChange(e.target.value)}
                value={mobileInputValue}
                placeholder=""
                data-testid="ProductSelection-mobileInput"
              />
            </div>
          </div>
          <div
            className={getClassName({
              descendantName: 'mobileListContainer',
            })}
          >
            <List listStyle={unorderedStyles.NONE}>
              {mobileProductList.map((element) => (
                <List.Item
                  href={element.value}
                  text={element.label}
                  key={uuid()}
                />
              ))}
            </List>
          </div>
        </Modal>
      )}
      <div className={getClassName({ descendantName: 'mainContentContainer' })}>
        <Heading
          type={types.Small}
          className={getClassName({ descendantName: 'mobileHeading' })}
        >
          {browseLabel}
        </Heading>
        <Button
          color={ButtonColor.PRIMARY}
          kind={ButtonKind.LINK}
          onClick={handleModalToggle}
          modalLabel="Product selection"
          id={'testingButtonWithModal'}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};

export default MobileView;
